import type { NavItem } from '../types';

export const navItems: NavItem[] = [
  { label: 'Board', path: '/shop' },
];
